import logo from './logo.svg';
import './App.css';
import React from "react";


import Layout from "./components/Layout";
import Home from "./homepage/home";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Checkout from './Checkout/checkout';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Layout page={<Home propdata='testings' />} />} />
      <Route path='/checkout' element={<Layout page={<Checkout />} />} /> 
    </Routes>
  </BrowserRouter> 
  );
}

export default App;
